import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AnalyticsModule } from '@flyfreely-portal-ui/analytics';
import { EnhancedHelpModule } from '@flyfreely-portal-ui/enhanced-help';
import { FlyFreelyTableModule } from '@flyfreely-portal-ui/flyfreely-table';
import { SharedUiModule } from '@flyfreely-portal-ui/ui';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ClipboardModule } from 'ngx-clipboard';
import { ReferralSource } from './referrals/referral-source.component';
import { Referrals } from './referrals/referrals.component';

@NgModule({
    imports: [
        CommonModule,
        ClipboardModule,
        TooltipModule,
        SharedUiModule,
        FlyFreelyTableModule,
        EnhancedHelpModule,
        AnalyticsModule
    ],
    declarations: [Referrals, ReferralSource],
    exports: [Referrals]
})
export class ReferralsModule {}
